import React, {Component} from 'react';
import styles from './styles.css';

export default class CheckBox extends Component {
	render() {
		const {children, className, ...props} = this.props;

		const label_classes = [styles['bsui-checkbox']];
		if (className) {
			label_classes.push(className);
		}

		return (
			<label className={label_classes.join(' ')}>
				<span className={styles['bsui-checkbox__box']}>
					<input className={styles['bsui-checkbox__control']} type="checkbox" {...props} />
				</span>
				<span className={styles['bsui-checkbox__text']}>
					{children}
				</span>
			</label>
		);
	}
}